import init from "./init";

init();
